import { Box, HStack } from "@chakra-ui/react";
import React from "react";
import PaginationButton from "./PaginationButton";

const Pagination = ({ max, currentPage, handleSelectedPage }) => {
  const MAX_ITEMS_PER_PAGE = 50;

  const calculatePages = () => {
    let layout = [];
    for (
      let index = parseInt(currentPage) - 2 < 1 ? 1 : parseInt(currentPage) - 2;
      index <
      (parseInt(currentPage) + 3 > Number(max) / MAX_ITEMS_PER_PAGE + 1
        ? Number(max) / MAX_ITEMS_PER_PAGE + 1
        : parseInt(currentPage) + 3);
      index++
    ) {
      layout.push(index);
    }
    return layout;
  };

  const handleOnClick = (page) => {
    handleSelectedPage(page);
  };

  return (
    <HStack gap={"2px"}>
      {parseInt(currentPage) !== 1 && (
        <Box onClick={() => handleOnClick(1)}>
          <PaginationButton>{"<<"}</PaginationButton>
        </Box>
      )}
      {parseInt(currentPage) !== 1 && (
        <Box onClick={() => handleOnClick(currentPage - 1)}>
          <PaginationButton>{"<"}</PaginationButton>
        </Box>
      )}
      {calculatePages().map((page) => (
        <Box
          key={page}
          onClick={() => currentPage !== page && handleOnClick(page)}
        >
          <PaginationButton
            isSelected={parseInt(currentPage) === parseInt(page)}
          >
            {page}
          </PaginationButton>
        </Box>
      ))}
      {Number(max) / MAX_ITEMS_PER_PAGE > parseInt(currentPage) && (
        <Box onClick={() => handleOnClick(currentPage + 1)}>
          <PaginationButton>{">"}</PaginationButton>
        </Box>
      )}
      {Number(max) / MAX_ITEMS_PER_PAGE > parseInt(currentPage) && (
        <Box onClick={() => handleOnClick(Number(max) / MAX_ITEMS_PER_PAGE)}>
          <PaginationButton>{">>"}</PaginationButton>
        </Box>
      )}
    </HStack>
  );
};

export default Pagination;
